import { reportError } from 'utils/error'
import { AiErrorModal } from 'components/AiErrorModal/AiErrorModal'
import { useModals } from 'almanac-ui/Modal'
import { NewsletterIntroValues } from './Types'

type Mutation<T> = (values: NewsletterIntroValues) => Promise<T>

interface Props {
  onCancel?: () => void
}

export const useMutationWithErrorModal = <T,>(mutation: Mutation<T>, { onCancel }: Props) => {
  const { openModal, closeModal } = useModals()

  const generate = async (values: NewsletterIntroValues) => {
    try {
      await mutation(values)
    } catch (e) {
      reportError(e)
      openModal(AiErrorModal, {
        onCancel: () => {
          closeModal()
          onCancel?.()
        },
        onTryAgain: () => {
          closeModal()
          generate(values)
        },
      })
    }
  }

  return generate
}
